export default __webpack_public_path__ + "static/media/work.7461b032.png";